import './create-tab.scss';

import { useContext, useState } from 'react';
import { FormProvider } from 'react-hook-form';

import { AdaptiveFormSteps, Button, FormSteps } from '@/components/Shared/ui';

import { CreateTabContext } from '../../LlpOrder';
import {
  AdditionalDocuments,
  ContactsData,
  FinanceForms,
  GeneralInfo,
  LeasingInfo,
  LeasingSubject,
  ManagerInfo
} from '../../entities';
import { VALIDATION_TRIGGER_ARRAY, stepCountItemsData } from './constants';
import { useCreateLeasing, useLeasingForm, useStepCount } from './hooks';

const CreateTab: React.FC = () => {
  const { isFieldsFrozen } = useContext(CreateTabContext);

  const { methods } = useLeasingForm();
  const { createLoading, handleCreate } = useCreateLeasing();

  const { stepCountItems, incrementMaxFieldsCount, decrementMaxFieldsCount } =
    useStepCount({ control: methods.control });

  const [currentTab, setCurrentTab] = useState(0);

  const handleNext = async () => {
    // Валидируем только поля текущего таба
    const isValid = await methods.trigger(VALIDATION_TRIGGER_ARRAY[currentTab]);
    if (isValid) {
      if (currentTab === 0) {
        setCurrentTab(1); // Переключаемся на следующий таб
      } else {
        methods.handleSubmit(handleCreate)(); // Отправляем форму
      }
    }
  };

  const handleStep = async (val: number) => {
    let isValid = true;
    if (!isFieldsFrozen)
      isValid = await methods.trigger(VALIDATION_TRIGGER_ARRAY[0]);
    if (val === 0) {
      setCurrentTab(val);
    } else if (val === 1 && isValid) {
      setCurrentTab(val);
    }
  };

  return (
    <FormProvider {...methods}>
      <div className="create-tab">
        <div className="create-tab__side-container-adaptive">
          <AdaptiveFormSteps
            currentStep={currentTab + 1}
            steps={stepCountItemsData}
            onChange={handleStep}
            textCenter
          />
        </div>
        <form className="create-tab__form">
          {currentTab === 0 && (
            <>
              <div className="create-tab__section">
                <h2>Предмет лизинга</h2>
                <LeasingSubject
                  incrementMaxFieldsCount={incrementMaxFieldsCount.bind(
                    null,
                    0
                  )}
                  decrementMaxFieldsCount={decrementMaxFieldsCount.bind(
                    null,
                    0
                  )}
                />
              </div>
              <div className="create-tab__section">
                <h2>Лизинговая информация</h2>
                <LeasingInfo />
              </div>
              <div className="create-tab__section">
                <h2>Общая информация</h2>
                <GeneralInfo />
              </div>
            </>
          )}

          {currentTab === 1 && (
            <>
              <div className="create-tab__section">
                <h2>Контактные данные</h2>
                <ContactsData />
              </div>
              <div className="create-tab__section">
                <h2>Информация о руководителе</h2>
                <ManagerInfo />
              </div>
              <FinanceForms />
              <AdditionalDocuments />
            </>
          )}

          {!isFieldsFrozen && (
            <Button
              type="submit"
              variant="filled-red"
              onClick={(e) => {
                e.preventDefault();
                handleNext();
              }}
              className="create-tab__submit"
              disabled={Object.values(methods.formState.errors).length !== 0}
              fullWidth
              isLoading={createLoading}
            >
              {currentTab === 0 ? 'Продолжить' : 'Создать заявку'}
            </Button>
          )}
        </form>

        <div className="create-tab__side-container">
          <FormSteps
            currentStep={currentTab + 1}
            steps={stepCountItems}
            onChange={handleStep}
          />
        </div>
      </div>
    </FormProvider>
  );
};

export default CreateTab;
